/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Dialog, Box, Typography, Button, InputBase, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

const FONT = "'Open Sans', sans-serif";

const AddCartDialog = ({ open, onClose, onAdd, loading = false }) => {
  const [name, setName] = useState('');

  useEffect(() => {
    if (!open) setName('');
  }, [open]);

  const handleAdd = () => {
    if (!name.trim()) return;
    onAdd(name.trim());
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{ alignItems: 'flex-start' }}
      slotProps={{ backdrop: { sx: { backgroundColor: 'rgba(0, 37, 59, 0.28)' } } }}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          p: '16px 32px',
          minWidth: '485px',
          maxWidth: '485px',
          fontFamily: FONT,
          mb: '395px',
        },
      }}
    >
      <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#1A2B3C', fontFamily: FONT, mb: '20px' }}>
        Ajouter un panier
      </Typography>

      {/* Input */}
      <Box sx={{
        border: '1.5px solid #DEE5EE',
        borderRadius: '8px',
        backgroundColor: '#F8FAFC',
        px: '14px',
        py: '12px',
        mb: '20px',
        '&:focus-within': { borderColor: '#007BC6' },
        transition: 'border-color 0.15s',
      }}>
        <InputBase
          fullWidth
          autoFocus
          disabled={loading}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nom du panier"
          onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
          sx={{
            fontFamily: FONT,
            fontSize: '14px',
            color: '#1A2B3C',
            '& .MuiInputBase-input': {
              p: 0,
              fontFamily: FONT,
              '&::placeholder': { color: '#9CA3AF', opacity: 1 },
            },
          }}
        />
      </Box>

      {/* Actions */}
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <Button
          fullWidth
          onClick={handleClose}
          disabled={loading}
          startIcon={<CloseIcon sx={{ fontSize: 15 }} />}
          sx={{
            color: '#4D4D4D',
            fontSize: '14px',
            fontWeight: 600,
            textTransform: 'none',
            fontFamily: FONT,
            border: '1px solid #DEE5EE',
            borderRadius: '8px',
            py: '10px',
            backgroundColor: '#fff',
            '&:hover': { backgroundColor: '#F5F7FA' },
          }}
        >
          Annuler
        </Button>
        <Button
          fullWidth
          onClick={handleAdd}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={15} sx={{ color: '#fff' }} /> : <AddIcon sx={{ fontSize: 16 }} />}
          sx={{
            backgroundColor: '#007BC6',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 600,
            textTransform: 'none',
            fontFamily: FONT,
            borderRadius: '8px',
            py: '10px',
            '&:hover': { backgroundColor: '#0069A8' },
            '&.Mui-disabled': { backgroundColor: '#007BC6', color: '#fff', opacity: 0.7 },
          }}
        >
          Ajouter
        </Button>
      </Box>
    </Dialog>
  );
};

export default AddCartDialog;